export default {
    parentCommittees: [],
    parentCommitteeIsLoading: false
}